import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-banker-group-form',
  templateUrl: './banker-group-form.component.html',
  styleUrls: ['./banker-group-form.component.scss']
})
export class BankerGroupFormComponent implements OnInit {

  public data:any = {status: 1};
  constructor(private http: HttpService, private activatedRoute: ActivatedRoute) { 
    this.activatedRoute.params.subscribe(params => {
      if(params['uuid']) {
        this.init(params['uuid']);
      }
    });
  }

  ngOnInit(): void {
  }

  async init(uuid: string) {
    this.data = await this.http.post("/admin/banker-group/get", {uuid: uuid});
  }

  async submit() {
    let y:any = await this.http.post("/admin/banker-group/update", this.data);
    if(y.status) {
      this.http.navigate(['/lo', this.http.getStaticSelectedCompany(), 'banker-group-management']);
    } 
  }

}
